<div class="d-flex align-items-center border-bottom ps-4" style="min-height: 60px;">

    <!-- RIGHT SIDE - All items grouped together and pushed to the far right -->
    <div class="d-flex align-items-center ms-auto">

        <!-- 1. Chat Button -->
        <div *ngIf="canAccessChat && !skeditPay && !isLathamOrdersOnly" class="pt-1 me-3">
            <a class="btn text-primary c-pointer chat-box" (click)="openChat($event)">
                <i class="fal fa-comment fa-2x border-0"></i>
                <span *ngIf="newChatMessagesCount" class="ms-n2 badge badge-danger badge-pill bg-danger py-1 align-self-start">
                    {{newChatMessagesCount}}
                </span>
            </a>
        </div>

        <!-- 2. Clock In / Out / Break + Logout -->
        <div class="logout-container d-flex align-items-center me-3">
            <button *ngIf="!currentTimeclockEntry && !isTimeclockExempt && !isQPro && !isLathamOrdersOnly"
                    type="button" class="btn btn-outline-success me-2" (click)="clockIn()">
                Clock In
            </button>
            <button *ngIf="currentTimeclockEntry && !isTimeclockExempt && !isQPro && !isLathamOrdersOnly"
                    type="button" class="btn btn-outline-danger me-2" (click)="clockOut()">
                Clock Out
            </button>
            <button *ngIf="currentTimeclockEntry && !isTimeclockExempt && !isQPro && !isLathamOrdersOnly && !currentTimeclockEntry.isOnBreak"
                    type="button" class="btn btn-outline-primary me-2" (click)="startBreak()">
                Break
            </button>
            <button *ngIf="currentTimeclockEntry && !isTimeclockExempt && !isQPro && !isLathamOrdersOnly && currentTimeclockEntry.isOnBreak"
                    type="button" class="btn btn-outline-danger me-2" (click)="endBreak()">
                End Break
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="logout()">
                Log Out
            </button>
        </div>

        <!-- 3. User Name + Profile Picture + Logs Dropdown -->
        <div class="user-hover-container"
             (mouseenter)="onMouseEnter()"
             (mouseleave)="onMouseLeave()">

            <div class="text-end" style="font-size:12px; line-height: 1rem;">
                Hello, {{ firstName }}
                <br>{{ companyName }}
            </div>

            <div class="users-name">
                <a href="/userSettings" [routerLink]="['/userSettings']">
                    <img src="{{ profilePictureUrl }}" alt="{{ fullName }}" class="profile-pic" />
                </a>
            </div>

            <div *ngIf="showLogs" class="logs-dropdown">
                <ng-container *ngFor="let log of systemLogs">
                    <a *ngIf="getLogLink(log)"
                       [routerLink]="getLogLink(log)"
                       [queryParams]="getLogQueryParams(log)"
                       class="log-link">

                        <span class="log-main">{{ getMainLogText(log) }}</span>
                        <span class="log-date">({{ getLogDateOnly(log) }})</span>

                    </a>
                </ng-container>
            </div>
        </div>

        <!-- 4. Notifications -->
        <div class="align-self-top ms-3">
            <notifications></notifications>
        </div>

    </div>
</div>

<div #trialRef class="trial bg-primary">
    <div class="p-0 m-0">
        <h3 style="opacity: 1; color: white;">Your free trial expires on {{trialEndDate | date: 'mediumDate'}}.</h3>
    </div>
</div>

<skedit-chat *ngIf="canAccessChat" #chatRef></skedit-chat>
<job-edit-dialog #jobEditDialogRef></job-edit-dialog>